import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./GuestServing.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddGuestServingEntity, GuestServingEntity } from "../../entities/GuestServingEntity";
import { GoDotFill } from "react-icons/go";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { LuImagePlus } from "react-icons/lu";
import { format } from "date-fns";
import { VendorDropoffService } from "../../services/vendors_dropoff";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import PopupPilih from "../../components/Popup/PopupPilih";
import { KaryawanService } from "../../services/karyawans";
import { VendorPorsiService } from "../../services/vendors_porsi";
import { GuestServingsService } from "../../services/guest_servings";

export default function GuestServing() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const stateShowLoading = context.stateShowLoading
    const contextUserEntity = context.contextUserEntity;
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //
    const [tableData, setTableData] = useState<GuestServingEntity[]>([]);

    const [selectedGuestServing, setSelectedGuestServing] = useState<GuestServingEntity | null>(null);
    const [selectedAddGuestServing, setSelectedAddGuestServing] = useState<AddGuestServingEntity | null>(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showPopupPilih, setShowPopupPilih] = useState(false);
    const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();

    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const handleSelectVendorPorsi = async () => {
        contextShowLoadingFunc(true);
        setShowPopup(false)
        try {
            const resp = await VendorPorsiService.GetAllVendorsPorsi(null, null);
            const data: {
                id: number,
                outlet: string,
                shift: number,
                sisa_regular: number,
                sisa_vegetarian: number
            }[] = []
            resp.map((val) => { data.push({ id: val.id, outlet: val.lokasi, shift: val.shift, sisa_regular: val.sisa_regular, sisa_vegetarian: val.sisa_vegetarian }) })
            setPopUpPilihEntity(new PopUpPilihEntity({
                popupTitle: 'Pilih Porsi',
                tableContent: data,
                onClick: (row) => {
                    setSelectedAddGuestServing((prevState: AddGuestServingEntity | null) => {
                        return new AddGuestServingEntity({
                            ...prevState,
                            id_vendor_porsi: row.id,
                            outlet: row.outlet,
                            shift: row.shift,
                            porsi_reguler_available: row.sisa_regular,
                            porsi_vegetarian_available: row.sisa_vegetarian,
                        })
                    });
                    setShowPopup(true)
                },
                onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
            }))
            setShowPopupPilih(true);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleAddNew = () => {
        setSelectedAddGuestServing({
            tanggal: new Date()
        });
        setSelectedGuestServing(null);
        setShowPopup(true);
    }

    const handlePopupDetail = (row: GuestServingEntity) => {
        setSelectedGuestServing(row);
        setShowPopup(true)
    }

    const handleSaveAddVendorDropOff = async () => {
        if (selectedAddGuestServing == null || selectedAddGuestServing.tanggal == null || selectedAddGuestServing.outlet == null
            || selectedAddGuestServing.customer_name == null || selectedAddGuestServing.shift == null
            || selectedAddGuestServing.id_customer == null || selectedAddGuestServing.payment == null
            || selectedAddGuestServing.id_vendor_porsi == null || selectedAddGuestServing.type == null
        ) return

        contextShowLoadingFunc(true);
        try {
            const resp = await GuestServingsService.AddGuestServings({
                id_vendor_porsi: selectedAddGuestServing.id_vendor_porsi,
                customer_name: selectedAddGuestServing.customer_name,
                id_customer: selectedAddGuestServing.id_customer,
                serving_type: selectedAddGuestServing.type,
                payment_type: selectedAddGuestServing.payment,
            });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedGuestServing(null);
            setSelectedAddGuestServing(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleSaveUpdateVendorDropOff = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedGuestServing == null) { throw new Error("guest serving not selected") }
            const resp = await GuestServingsService.UpdateGuestServings(
                selectedGuestServing,
                {
                    customer_name: selectedGuestServing.customer_name,
                    id_customer: selectedGuestServing.id_customer.toString(),
                    payment_type: selectedGuestServing.payment,
                    serving_type: selectedGuestServing.type,
                }
            );
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedGuestServing(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleDeleteVendorDropOff = async () => {
        return contextShowAlertFunc(new AlertEntity({
            message: `Apakah anda yakin ingin menghapus Guest Serving pada ${selectedGuestServing?.customer_name} ?`,
            onOk: async () => {
                contextShowLoadingFunc(true);
                try {
                    if (selectedGuestServing == null) { throw new Error("guest serving not selected") }
                    const resp = await GuestServingsService.DeleteGuestServings(selectedGuestServing);
                    await generateData();
                    contextShowLoadingFunc(false);
                    setSelectedGuestServing(null);
                    setShowPopup(false);
                    contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
                } catch (error: any) {
                    contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
                    contextShowLoadingFunc(false);
                }
            },
            withCancel: true,
            withOk: true,
            level: 2
        }))
    }

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await GuestServingsService.GetAllGuestServings()
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Guest Serving"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                                    <button className="cardButton" onClick={() => handleAddNew()} >
                                        Add New
                                    </button>
                                </div>
                            </div>
                        </>
                    }
                />
                <div
                    style={{
                        height: "65vh",
                        overflow: "auto"
                    }}>
                    <table className="tableclickcell">
                        {tableData.length > 0 ?
                            <>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Tanggal</th>
                                        <th>Shift</th>
                                        <th>Vendor</th>
                                        <th>Lokasi</th>
                                        <th>Customer Name</th>
                                        <th>ID Customer</th>
                                        <th>Payment</th>
                                        <th>Type</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((row, idx) => {
                                        return <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{format(row.tanggal, "yyyy-MM-dd")}</td>
                                            <td>{row.shift == 0 ? "No Shift" : row.shift}</td>
                                            <td>{row.vendor}</td>
                                            <td>{row.lokasi}</td>
                                            <td>{row.customer_name}</td>
                                            <td>{row.id_customer}</td>
                                            <td>{row.payment}</td>
                                            <td>{row.type}</td>
                                            <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /></td>
                                        </tr>
                                    })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead><tr><th>no data available yet!</th></tr></thead>
                            </>
                        }
                    </table>
                </div>

                {/* Popup Detail */}
                <Popup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    popupTitle={selectedGuestServing == null ? "Add New" : `Edit Guest Serving Pada ${selectedGuestServing?.customer_name} (${selectedGuestServing.id_customer})`}
                    popupContent={
                        selectedGuestServing == null ?
                            <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="date" value={format(selectedAddGuestServing?.tanggal ?? new Date(), "yyyy-MM-dd")} readOnly style={{ backgroundColor: "silver" }}
                                            />
                                            <div className={css.label}> Customer Name<span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddGuestServing?.customer_name ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddGuestServing((prevState: AddGuestServingEntity | null) => {
                                                        return new AddGuestServingEntity({
                                                            ...prevState,
                                                            customer_name: event.target.value
                                                        })
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Payment<span style={{ color: "red" }}>*</span></div>
                                            <select style={{ color: "black", backgroundColor: "white", borderRadius: "8px", border: "2px solid black" }}
                                                value={selectedAddGuestServing?.payment ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddGuestServing((prevState: (AddGuestServingEntity | null)) => {
                                                        return new AddGuestServingEntity({
                                                            ...prevState,
                                                            payment: ((event.target.value == "QRIS") ? "QRIS" : (event.target.value == "CASH" ? "CASH" : undefined))
                                                        })
                                                    });
                                                }}>
                                                <option >Choose Payment...</option>
                                                <option value={"QRIS"}>QRIS</option>
                                                <option value={"CASH"}>CASH</option>
                                            </select>
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Outlet & Shift<span style={{ color: "red" }}>*</span></div>
                                            <input
                                                className={css.inputedit}
                                                type="text"
                                                readOnly
                                                value={selectedAddGuestServing?.outlet == null ? "" : `${selectedAddGuestServing?.outlet} - ${selectedAddGuestServing?.shift}`}
                                                onClick={() => { handleSelectVendorPorsi() }}
                                            />
                                            <div className={css.label}> ID Customer<span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddGuestServing?.id_customer ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddGuestServing((prevState: AddGuestServingEntity | null) => {
                                                        return new AddGuestServingEntity({
                                                            ...prevState,
                                                            id_customer: event.target.value
                                                        })
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Type<span style={{ color: "red" }}>*</span></div>
                                            <select style={{ color: "black", backgroundColor: "white", borderRadius: "8px", border: "2px solid black" }}
                                                value={selectedAddGuestServing?.type ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddGuestServing((prevState: (AddGuestServingEntity | null)) => {
                                                        return new AddGuestServingEntity({
                                                            ...prevState,
                                                            type: ((event.target.value == "REGULAR") ? "REGULAR" : (event.target.value == "VEGETARIAN" ? "VEGETARIAN" : undefined))
                                                        })
                                                    });
                                                }}>
                                                <option >Choose Type...</option>
                                                <option value={"REGULAR"}>REGULAR</option>
                                                <option value={"VEGETARIAN"}>VEGETARIAN</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveAddVendorDropOff() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Tanggal <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="date" value={format(selectedGuestServing?.tanggal, "yyyy-MM-dd")} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Customer Name <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedGuestServing?.customer_name ?? ""}
                                                onChange={(event) => {
                                                    setSelectedGuestServing((prevState: GuestServingEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new GuestServingEntity({
                                                                ...prevState,
                                                                customer_name: event.target.value
                                                            })
                                                        }
                                                    });
                                                }} />
                                            <div className={css.label}> Payment <span style={{ color: "red" }}>*</span></div>
                                            <select style={{ color: "black", backgroundColor: "white", borderRadius: "8px", border: "2px solid black" }}
                                                value={selectedGuestServing?.payment ?? ""}
                                                onChange={(event) => {
                                                    setSelectedGuestServing((prevState: GuestServingEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new GuestServingEntity({
                                                                ...prevState,
                                                                payment: ((event.target.value == "QRIS") ? "QRIS" : "CASH")
                                                            })
                                                        }
                                                    });
                                                }}>
                                                <option value={selectedGuestServing.payment}>{selectedGuestServing.payment}</option>
                                                <option value={"QRIS"}>QRIS</option>
                                                <option value={"CASH"}>CASH</option>
                                            </select>
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Lokasi Outlet <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedGuestServing?.lokasi} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> Shift <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={(selectedGuestServing?.shift === 0 ? "No Shift" : selectedGuestServing?.shift) ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                                            <div className={css.label}> ID Customer <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedGuestServing?.customer_name ?? ""}
                                                onChange={(event) => {
                                                    setSelectedGuestServing((prevState: GuestServingEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new GuestServingEntity({
                                                                ...prevState,
                                                                customer_name: event.target.value
                                                            })
                                                        }
                                                    });
                                                }} />
                                            <div className={css.label}> Type<span style={{ color: "red" }}>*</span></div>
                                            <select style={{ color: "black", backgroundColor: "white", borderRadius: "8px", border: "2px solid black" }}
                                                value={selectedGuestServing?.type ?? ""}
                                                onChange={(event) => {
                                                    setSelectedGuestServing((prevState: (GuestServingEntity | null)) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new GuestServingEntity({
                                                                ...prevState,
                                                                type: ((event.target.value == "REGULAR") ? "REGULAR" : "VEGETARIAN")
                                                            })
                                                        }
                                                    });
                                                }}>
                                                <option >Choose Type...</option>
                                                <option value={"REGULAR"}>REGULAR</option>
                                                <option value={"VEGETARIAN"}>VEGETARIAN</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="secondaryButton" onClick={() => handleDeleteVendorDropOff()}>
                                                Delete
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveUpdateVendorDropOff() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                />

                {popUpPilihEntity != null
                    ? <PopupPilih
                        showPopup={showPopupPilih}
                        setShowPopup={setShowPopupPilih}
                        popUpPilihEntity={popUpPilihEntity}
                    />
                    : <></>}
            </div>
        </>
    );
}
